import store from '@/store/index'

export function getToken() {
  return store.state.user.token
}

export function getHasButtonAuth(value) {
  let hasAuth = false
  const roles = JSON.parse(store.state.user.buttonRoles)
  if (Array.isArray(value) && value.length > 0) {
    hasAuth = value.some((permissionRole) => roles.includes(permissionRole))
  }
  return hasAuth
}
